import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_SL_Paragraph, Component_SL_Text } from '@app/styles/skeleton-loaders';
import { LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_HPI.scss';
export const Component_AdvisorSL_HPI = () => {
    return _jsxs(LL_V_L, { className: 'c-asl-hpi', children: [_jsx(Component_SL_Paragraph, { rowCount: 4, variant: 'light' }), _jsx(Component_SL_Text, { width: 100, height: 12 })] });
};
//# sourceMappingURL=Component_AdvisorSL_HPI.js.map